import { css } from '@emotion/react';

import * as React from 'react';

import { Grid, breakpoints } from '@coursera/cds-core';

import ContentCard from 'bundles/shared-articles/components/hub-page/ArticleHubCard';
import Header from 'bundles/unified-seo-content-common/components/hub-page/CollectionHeader';
import { PAGE_TYPE } from 'bundles/unified-seo-content-common/constants';
import type { SEOContentPageType, SeoContentCard } from 'bundles/unified-seo-content-common/types';
import { getPageLink } from 'bundles/unified-seo-content-common/utils';

type Props = {
  title?: string;
  ctaLink?: string;
  ctaLabel?: string;
  contentList: Array<SeoContentCard | null>;
  isFeaturedContentRow?: boolean;
  pageType: SEOContentPageType;
  imageLazyLoad?: boolean;
};

const styles = {
  card: css`
    padding: 0 var(--cds-spacing-200) var(--cds-spacing-800);
    ${breakpoints.down('md')} {
      padding: 0 var(--cds-spacing-100) var(--cds-spacing-400);
    }
  `,
};

const ContentCards = ({
  contentList,
  isFeaturedContentRow,
  pageType,
  title,
  ctaLink,
  ctaLabel,
  imageLazyLoad = false,
}: Props) => {
  if (!contentList?.length) {
    return null;
  }

  const showHeader = title && ctaLink;

  return (
    <Grid container>
      {showHeader && <Header title={title} ctaLink={ctaLink} ctaLabel={ctaLabel} />}
      {contentList.map(
        (content) =>
          content?.slug && (
            <Grid item xs={6} md={4} key={content.slug} css={styles.card}>
              <ContentCard
                title={content.title || ''}
                subtitle={content.intro || ''}
                slug={content.slug}
                metadata={{
                  publishedDate: content.sys.firstPublishedAt,
                }}
                image={{
                  url: content.featuredImage?.url || '',
                  description: content.featuredImage?.description || '',
                }}
                cardLink={getPageLink({
                  slug: content.slug,
                  pageType: PAGE_TYPE.content,
                  seoContentPageType: pageType,
                })}
                isFeatured={isFeaturedContentRow}
                imageLazyLoad={imageLazyLoad}
              />
            </Grid>
          )
      )}
    </Grid>
  );
};

export default ContentCards;
